'use client';

import { Accordion, AccordionItem } from "@heroui/accordion";
import clsx from 'clsx';
import React from 'react';

const FaqList = ({
  className,
  data,
}: {
  className?: string;
  data: {
    question: string;
    answer: string | React.JSX.Element;
  }[];
}) => {
  return (
    <div className={clsx(className)}>
      <Accordion
        hideIndicator
        variant="splitted"
        className="gap-4 max-w-[218rem] !min-w-0"
        itemClasses={{
          indicator: 'bg-transparent ',
          base: '!shadow-none border border-gray-light2 p-8 ',
          title: 'text-gray-dark h6 font-medium hover:text-primary-blue',
          trigger: 'py-0',
          content: 'pt-10 pb-0 ',
        }}
      >
        {data.map((faq, index) => (
          <AccordionItem key={index} title={faq.question}>
            <p className="text-[#878896] body-normal">{faq.answer}</p>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default FaqList;
